module.exports = __webpack_public_path__ + "img/graph-text_2.a0d43973.svg";